import { TweenLite } from 'gsap'

class KeyNumber
{
    constructor(container)
    {     
        this._container = container;
        this._keyContainer = this._container.querySelector('.Article_key-number_title span');

        this._onScroll = this._onScroll.bind(this);

        this._init()
    }

    _init()
    {
        this._idx = {score:0}
        this._key = this._keyContainer.innerText
        if(this._key)
        { 
            window.addEventListener('scroll', this._onScroll)
        } 
    }

    _onScroll(position)
    {

        let rect = this._container.getBoundingClientRect()
        let p = -rect.y / (rect.height - window.innerHeight)
        let pv = -(rect.y - window.innerHeight) / (rect.height + window.innerHeight)

        let isEnter = p > 0 && p < 1
        let isVisible = pv > 0 && pv < 1

        // if (isVisible && !this._isVisible) { this._complete = true; this._isVisible = true; TweenLite.to(this._idx, 2, {score:this._key, roundProps:"score", onUpdate: () => { this._updateHandler() }, onComplete: () => { this._complete = false }, ease:Power4.easeOut}); }
        if (isVisible && !this._isVisible) { this._isVisible = true; }
        if (!isVisible && this._isVisible ) { this._isVisible = false; TweenLite.to(this._idx, 0.6, {score:0, roundProps:"score", onUpdate: () => { this._updateHandler() }, ease:Power4.easeOut}); }
        if (isEnter && !this._isEnter) { this._isEnter = true; TweenLite.to(this._idx, 2, {score:this._key, roundProps:"score", onUpdate: () => { this._updateHandler() }, ease:Power4.easeOut}); }
        if (!isEnter && this._isEnter) { this._isEnter = false; }

    }

    _updateHandler() 
    {
        this._keyContainer.innerText = this._idx.score;
    }
}

export default KeyNumber;


// WEBPACK FOOTER //
// ./src/js/libs/KeyNumber.js